module.exports = __webpack_public_path__ + "static/media/saurabh.1961a268.jpg";